import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import { getResourcePrettyName } from '../../../../forms/InitiWidgetFormHandler';
import type { MigratedPlotFormProps } from '../../../../forms/formHandlerShared';
import {
  getCoordinateSource,
  getName,
  isValid,
  setName,
} from '../../../../state/dashboard-element-operations';
import { EntityScopeSelector } from '../shared/EntityScopeSelector';
import {
  PlotConfigFormDivider,
  PlotConfigFormShell,
  PlotConfigNameField,
  PlotConfigSection,
  PlotConfigSubmitButton,
} from '../shared/plotConfigFormLayout';

function MapForm({ config, onSubmit, onChange }: MigratedPlotFormProps) {
  const [submitCount, setSubmitCount] = useState(0);
  const [isSending, setIsSending] = useState(false);
  const [validation, setValidation] = useState(isValid(config));

  const handleNameChange = (name: string) => {
    const newConfig = setName(name, config);
    setValidation(isValid(newConfig));
    onChange(newConfig);
  };

  const handleEntityScopeChange = (newConfig: typeof config) => {
    setValidation(isValid(newConfig));
    onChange(newConfig);
  };

  const handleSubmit: React.FormEventHandler = (e) => {
    e.preventDefault();
    setSubmitCount(submitCount + 1);
    if (validation[0]) {
      setIsSending(true);
      onSubmit(config).finally(() => setIsSending(false));
    }
  };

  return (
    <PlotConfigFormShell onSubmit={handleSubmit}>
      <PlotConfigNameField
        value={getName(config)}
        onChange={handleNameChange}
        errors={validation[1].name ?? []}
        submitted={submitCount > 0}
        required
      />

      <PlotConfigFormDivider />

      <EntityScopeSelector
        widget="map"
        config={config}
        onChange={handleEntityScopeChange}
        title="Site cartographié"
      />

      <PlotConfigFormDivider />

      <PlotConfigSection title="Source des coordonnées">
        <FormControl size="small" fullWidth disabled>
          <InputLabel id="map-coordinate-source-label">
            Source des coordonnées
          </InputLabel>
          <Select
            labelId="map-coordinate-source-label"
            value={getCoordinateSource(config)}
            label="Source des coordonnées"
          >
            <MenuItem value="site">{getResourcePrettyName('site')}</MenuItem>
          </Select>
        </FormControl>
      </PlotConfigSection>

      <PlotConfigSubmitButton isSending={isSending} />
    </PlotConfigFormShell>
  );
}

export default MapForm;
